<template>
  <div>
    <div class="header-container">
      <div class="name">企业钱包余额：</div>
      <div class="value">¥{{ account }}</div>
      <el-button type="success" @click="succ = true" v-if="auth == 1 || auth == 3">福利发放</el-button>
      <el-button @click="dingdong = true" v-if="auth == 1 || auth == 3">退款</el-button>
    </div>
    <router-view></router-view>
    <div>
      <!-- <div class="top-menu">
                <div >福利账单：</div>
                <el-input
                    class="search"
                    placeholder="请输入员工姓名/操作人/订单编号"
                    prefix-icon="el-icon-search"
                    v-model="searchStr">
                </el-input>
                <el-date-picker
                    v-model="rangeTime"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right">
                </el-date-picker>
                <el-button type="text" class="reset">重置</el-button>
                <el-button type="primary">查询</el-button>
                <el-button type="success">导出报表</el-button>
            </div> -->
      <el-table :data="list" style="width: 100%">
        <el-table-column label="发放人数" prop="userCount"></el-table-column>
        <el-table-column label="总金额" prop="total" :formatter="moenyFomat"></el-table-column>
        <el-table-column label="制表人" prop="name"></el-table-column>
        <el-table-column label="时间" prop="handlerTime">
          <template slot-scope="scope">
            {{ scope.row.handlerTime.replace(/\-/g, "/") }}
          </template>
        </el-table-column>
        <el-table-column label="审核状态" prop="status" :formatter="statusFomatter"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="gotoDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" :page-size="pageSize" @current-change="pageChange" :total="total">
      </el-pagination>
      <el-dialog title="请选择发放福利的方式" align="center" :visible.sync="succ" :before-close="handleDialogClose" class="succ"
        width="32%">
        <div class="boxs">
          <div class="btns">
            <span class="btn1">
              <el-button type="success" @click="gotoWelfare" v-if="auth == 1 || auth == 3">在线发放</el-button>
            </span>
            <span class="btn2">
              <form id="upload" enctype="multipart/form-data" method="post">
                <el-upload class="upload-demo" ref="upload" action="" accept=".xls" :limit="1" :show-file-list="true"
                  :http-request="handlePost" :auto-upload="true">
                  <el-button slot="trigger" type="success">选择.xls文件批量发放</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
              </form>
              <!-- <el-button type="success">选择.xls文件批量发放</el-button> -->
            </span>
          </div>
          <div class="tip">
            <span class="icon"></span>
            <span class="text">批量上传的文件扩展名必须为.xls文件，模板需统一，点击</span>
            <span class="download" @click="downLoadTemelate">下载模板</span>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="园区币退款" align="center" :visible.sync="dingdong" :before-close="dingdongClose" width="32%">
        <el-form class="refund" :model="form" label-width="120px">
          <el-form-item label="手机号">
            <el-input v-model="form.phone" style="width: 200px" placeholder="请输入员工手机号查找"></el-input>
            <el-button type="primary" @click="searchStaff" style="margin-left: 20px">查找</el-button>
          </el-form-item>
          <el-form-item v-show="form.realName" label="姓名">
            <div>{{ form.realName }}</div>
          </el-form-item>
          <el-form-item v-show="form.account" label="园区币余额">
            <div>{{ form.account }}元</div>
          </el-form-item>
          <el-form-item label="退款数量">
            <el-input v-model="form.amount" style="width: 200px" placeholder="请输入退款数量（元）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="refuntFn">退款</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { shop_url } from '../../global/index.js'
import { getMoneyById, getWelfareListById, getWelfareTemplate, postUpload, getStaffInfo, staffRefund } from '@/api/welfare'
import bus from '@/utils/bus'
import { downloadExcel } from '@/utils/downloadFetch'
export default {
  data () {
    return {
      money: 0,
      searchStr: '',
      rangeTime: [],
      list: [],
      page: 1,
      pageSize: 20,
      total: 0,
      auth: '',
      companyId: '',
      account: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      succ: false,
      fileList: [],
      form: {
        phone: '',
        account: '',
        realName: '',
        amount: ''
      },
      dingdong: false
    }
  },
  mounted () {
    this.auth = localStorage.auth
    this.companyId = localStorage.companyId
    this.getMoney()
    this.getWelfareList(1)
    bus.$on('changeCompany', id => {
      this.companyId = id
      this.getMoney()
      this.getWelfareList(1)
      this.auth = localStorage.auth
    })
  },
  destroyed () {
    this.$off('changeCompany')
  },
  methods: {
    gotoWelfare () {
      this.$router.push('/welfare')
    },
    getMoney () {
      getMoneyById(this.companyId).then(res => {
        this.account = parseFloat(res.data.account).toFixed(2)
      })
    },
    getWelfareList (page) {
      this.page = page
      getWelfareListById(this.companyId, this.page, this.pageSize).then(res => {
        console.log(res)
        this.list = res.welfareList
        console.log(this.list)
        this.total = res.count
      })
    },
    gotoDetail (obj) {
      this.$router.push({ path: '/detail', query: obj })
    },
    pageChange (page) {
      this.getWelfareList(page)
    },
    timeFomatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    statusFomatter (row, col) {
      let str = row[col.property]

      switch (str) {
        case 0:
          str = '待审核'
          break
        case 1:
          str = '通过'
          break
        case 2:
          str = '驳回'
          break
        default:
          str = '未知'
          break
      }
      return str
    },
    handleDialogClose () {
      this.succ = false
    },
    dingdongClose () {
      this.dingdong = false
      this.form = {
        phone: '',
        account: '',
        realName: '',
        amount: ''
      }
    },
    downLoadTemelate () {
      let company = JSON.parse(localStorage.getItem('company'))
      console.log(company.name)
      downloadExcel({
        method: 'get',
        url: `${shop_url}/shop/app/company/template/download/${this.companyId}`,
        fileName: `员工福利发放统计模板`
      })
        .then(res => { })
        .catch(err => {
          this.$message('下载失败')
        })
    },
    handlePost (file) {
      const fd = new FormData()
      fd.append('companyId', this.companyId)
      fd.append('file', file.file)
      postUpload(fd).then(res => {
        console.log(res)
        if (res.data.resultData.length > 0) {
          if (res.data.count) {
            this.$message('上传成功,本次新增员工：' + res.data.count + '人')
          } else {
            this.$message('上传成功')
          }
          // this.$message('上传成功,本次新增员工：'+res.data.count+'人');
          let arr = JSON.stringify(res.data.resultData)
          localStorage.setItem('arr', arr)
          setTimeout(() => {
            this.$refs.upload.fileList = []
            this.$router.push({ path: '/welfare' })
          }, 1000)
        } else {
          this.$refs.upload.fileList = []
          this.$message('福利人员不能为空，请核实后再提交！')
        }
      }).catch(err => {
        this.$message('上传文件失败')
        this.$refs.upload.fileList = []
      })
    },
    searchStaff () {
      if (!this.form.phone) {
        return this.$message.error('请输入员工手机号')
      }
      let data = {
        phone: this.form.phone,
        companyId: this.companyId
      }
      getStaffInfo(data).then(res => {
        this.form.realName = res.userInfo.realName
        this.form.account = res.userInfo.account
      })
    },
    refuntFn () {
      if (!this.form.phone) {
        return this.$message.error('请输入正确的退款金额')
      }
      if (this.form.amount) {
        let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/
        if (reg.test(this.form.amount)) {

        } else {
          return this.$message.error('请输入正确的退款金额')
        }
      } else {
        return this.$message.error('请输入退款金额')
      }
      if (Number(this.form.amount) > Number(this.form.account)) {
        return this.$message.error('退款额度超出用户余额')
      }
      let data = {
        amount: (this.form.amount * 100).toFixed(0),
        companyId: this.companyId,
        phone: this.form.phone
      }
      staffRefund(data).then(res => {
        this.$message.success('退款成功')
        this.dingdongClose()
        this.getMoney()
        this.getWelfareList(1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
%row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-container {
  @extend %row;
  justify-content: flex-start;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 20px;

  .name {
    font-size: 30px;
    color: #333;
  }

  .value {
    font-size: 30px;
    color: coral;
    margin-right: 20px;
  }
}

.top-menu {
  @extend %row;
  justify-content: flex-start;
  margin: 10px 0;

  .search {
    width: 20%;
    margin-right: 20px;
  }

  .reset {
    margin-left: 40px;
  }
}

.succ {
  .boxs {
    width: 100%;
    height: 154px;
    justify-content: flex-start;

    .btns {
      display: flex;
      width: 100%;
      height: 100px;
      flex-direction: column;

      .btn1 {
        button {
          width: 80%;
          color: #00c261;
          background: #fff;
        }
      }

      .btn2 {
        .upload-demo {
          ::v-deep  .el-upload--text {
            width: 100%;

            button {
              width: 80%;
              margin-top: 10px;
              color: #00c261;
              background: #fff;
            }
          }
        }
      }
    }

    .tip {
      display: flex;
      font-size: 12px;
      line-height: 16px;
      justify-content: center;
      margin-top: 30px;

      .icon {
        flex-basis: 20px;
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("../../assets/icon.png") no-repeat;
      }

      .text {
        flex-basis: 310px;
        text-align: left;
      }

      .download {
        flex-basis: 50px;
        color: #409eff;
        cursor: pointer;
        text-align: left;
      }
    }
  }
}

.refund {
  text-align: left;
}
</style>
